import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Water.svg",
  "use": "Water.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Water.svg\"><path d=\"M32.01,56.0177a17.9993,17.9993,0,0,1-18-17.9985c0-11.7329,12.9854-27.3521,16.8976-31.5285a1.5122,1.5122,0,0,1,2.2049,0C37.0253,10.6671,50.01,26.2863,50.01,38.0192A17.9992,17.9992,0,0,1,32.01,56.0177ZM28.9891,15.7169A64.6121,64.6121,0,0,0,24.01,37.0209a1.0258,1.0258,0,0,1-1,1h-3a.9639.9639,0,0,1-1-1c.4069-6.5815,5.0121-16.2616,9.0486-21.7608C28.4251,14.7614,29.2393,15.157,28.9891,15.7169Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol